import React from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

import { Alert } from '@shared/components/bootstrap/alert';
import { Percent } from '@shared/components/helpers/percent';

import type { Renewal__PackageFragment } from '@portal/schema';

export const RenewalBanner: FC<{
  packages: Renewal__PackageFragment[];
}> = ({ packages }) => {
  if (!packages.length) return null;

  const savings = Math.max(...packages.map((entry) => entry.percent));

  return (
    <Link to="/renew">
      <Alert style="info">
        💰 Stay & Save: Renew today and receive <Percent value={savings} /> off your monthly storage bill!
      </Alert>
    </Link>
  );
};
